import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loading } from "@/components/common";
import { Info } from "lucide-react";
import { fmtDate } from "@/utils/format";

export default function EmployeeProfile() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/portal/me").then(({ data }) => setP(data)).catch(() => setP({})); }, []);
  if (p === null) return <Loading />;

  const rows = [
    ["Employee ID", p.employee_id],
    ["Designation", p.designation || "—"],
    ["Department", p.department || "—"],
    ["Email", p.email],
    ["Date of joining", fmtDate(p.doj)],
    ["Date of birth", fmtDate(p.dob)],
    ["Bank", p.bank_name || "—"],
    ["Account number", p.bank_account_masked || "—"],
    ["IFSC", p.ifsc || "—"],
    ["UAN", p.uan || "—"],
    ["ESI number", p.esi_number || "—"],
  ];

  return (
    <div data-testid="employee-profile">
      <h1 className="font-display text-2xl font-semibold mb-1">{p.full_name}</h1>
      <p className="text-sm text-muted-foreground mb-6">Your details on record.</p>

      <div className="bg-card border border-border rounded-md divide-y divide-border">
        {rows.map(([k, v]) => (
          <div key={k} className="px-5 py-3.5 flex items-center justify-between gap-4">
            <span className="label-caps">{k}</span>
            <span className="text-sm font-medium text-right tabular">{v}</span>
          </div>
        ))}
      </div>

      <div className="flex items-start gap-2.5 bg-secondary/60 border border-border rounded-md px-4 py-3 mt-4 text-sm text-muted-foreground">
        <Info className="w-4 h-4 mt-0.5 shrink-0" />
        <p>Something not right? These records are managed by your administrator — please contact them for any corrections.</p>
      </div>
    </div>
  );
}
